export default __webpack_public_path__ + "static/media/insta.224296f5.webp";